import router from '@/router/index.js'
import { db } from '@/services/firebase'
import * as types from '@/store/mutation-types.js'

// state
export const state = {
  currentUser: null,
  userProfile: {}
}
// mutations
export const mutations = {
  [types.SET_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [types.SET_USER_PROFILE] (state, val) {
    state.userProfile = val
  },
  [types.LOGOUT] (state) {
    state.currentUser = null
    state.userProfile = {}
  }
}
// actions
export const actions = {
  setCurrentUser ({ commit, state }, payload) {
    commit(types.SET_CURRENT_USER, payload)
  },
  fetchUserProfile ({ commit, state }) {
    return new Promise(resolve => {
      setTimeout(() => {
        db.collection('users').doc(state.currentUser).get().then(res => {
          commit(types.SET_USER_PROFILE, res.data())
          if (res.data().admin) {
            router.push({name: 'Dashboard'})
          } else {
            router.push({name: 'Home'})
          }
        }).catch(err => {
          console.log(err)
        })
        resolve()
      }, 1000)
    })
  },
  logout ({ commit }) {
    commit(types.LOGOUT)
  }
}
// getters
export const getters = {
  currentUser: state => state.currentUser,
  userProfile: state => state.userProfile
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js